import React from "react"
import styles from "./Team.module.css";

interface UserRoleProps {
    role: string
}

export function roleLabel(role: string) {
    const word = role.replace(/^(ROLE|PERM)_/, "").replace(/_/g, " ").toLowerCase();
    return word.charAt(0).toUpperCase() + word.slice(1);
}

export default function UserRole({role}: UserRoleProps) {
    const isAdmin = /ADMIN|MANAGE/.test(role);
    return <span className={`${styles.role} ${isAdmin ? styles.roleAdmin : ""}`} title={role}>{roleLabel(role)}</span>
}
